import type { Brand } from '@openx/types/brand';
import type { ConstValues } from '@openx/types/helpers';
import type { OptionsMap } from '@openx/types/options';
import type { Action } from 'redux';

export const BrandsActionType = {
  LOAD_BRANDS_OPTIONS_BEGIN: 'LOAD_BRANDS_OPTIONS_BEGIN',
  LOAD_BRANDS_OPTIONS: 'LOAD_BRANDS_OPTIONS',
  FETCHED_BRAND_IDS: 'FETCHED_BRAND_IDS',
  SEARCH_BRANDS_BEGIN: 'SEARCH_BRANDS_BEGIN',
  SEARCH_BRANDS_FINISH: 'SEARCH_BRANDS_FINISH',
} as const;
export type BrandsActionType = ConstValues<typeof BrandsActionType>;

export function createLoadOptionsBeginAction(): Action<typeof BrandsActionType.LOAD_BRANDS_OPTIONS_BEGIN> {
  return {
    type: BrandsActionType.LOAD_BRANDS_OPTIONS_BEGIN,
  };
}

export interface LoadBrandsOptionsAction extends Action<typeof BrandsActionType.LOAD_BRANDS_OPTIONS> {
  type: typeof BrandsActionType.LOAD_BRANDS_OPTIONS;
  options: OptionsMap;
  [key: string]: unknown;
}

export function createLoadBrandsOptionsAction(brands: Brand[]): LoadBrandsOptionsAction {
  const options = brands.reduce((accumulated, brand) => {
    accumulated[brand.id] = brand;
    return accumulated;
  }, {});

  return {
    options,
    type: BrandsActionType.LOAD_BRANDS_OPTIONS,
  };
}

export interface SearchBrandsBeginAction extends Action<typeof BrandsActionType.SEARCH_BRANDS_BEGIN> {
  phrase: string;
  [key: string]: unknown;
}

export function createSearchBrandsBeginAction(phrase: string): SearchBrandsBeginAction {
  return {
    phrase,
    type: BrandsActionType.SEARCH_BRANDS_BEGIN,
  };
}

export interface SearchBrandsFinishAction extends Action<typeof BrandsActionType.SEARCH_BRANDS_FINISH> {
  data: Brand[];
  [key: string]: unknown;
}

export function createSearchBrandsFinishAction(data: Brand[]): SearchBrandsFinishAction {
  return {
    data,
    type: BrandsActionType.SEARCH_BRANDS_FINISH,
  };
}

export interface FetchedBrandIdsAction extends Action<typeof BrandsActionType.FETCHED_BRAND_IDS> {
  brandIds: string[];
  [key: string]: unknown;
}

export function createFetchedBrandIdsAction(brandIds: string[]): FetchedBrandIdsAction {
  return {
    brandIds,
    type: BrandsActionType.FETCHED_BRAND_IDS,
  };
}

export type BrandsAction =
  | LoadBrandsOptionsAction
  | SearchBrandsBeginAction
  | SearchBrandsFinishAction
  | Action<typeof BrandsActionType.LOAD_BRANDS_OPTIONS_BEGIN>
  | FetchedBrandIdsAction;
